module.exports = __webpack_public_path__ + "img/ic_new_version.a5103fb4.jpg";